import React from "react";
import { ClockLoader } from "react-spinners";
import { Backdrop } from "@mui/material";

export default function Loader({ show }) {
    return (
        <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={show}
        >
            <ClockLoader size={80} color="var(--primary)" />
        </Backdrop>
    );
}